{
  "#SSO": {
    "PAGES": {
      "PLEASE_WAIT": "Bitte warten...",
      "PROGRESS": "Sie werden automatisch angemeldet"
    },
    "MESSAGES": {
      "ERROR": {
        "UNAUTHORIZED": "Der Anmeldeschlüssel ist nicht gültig",
        "NO_CONNECTION": "Es konnte keine Verbindung zum Server hergestellt werden. Bitte überprüfen Sie Ihre Internetverbindung oder versuchen Sie es später nochmal."
      }
    }
  }
}
